// ---------------------------------------------------------------------------
// CockpitStrip — faixa fixa do ProgressDrawerV3 (sempre visivel).
// ---------------------------------------------------------------------------
// Faixa imobilizada acima do rail+conteudo com 4 KPIs lado a lado, nesta
// ordem: Inputs enviados · Pendencias · Calculos · Meses calculados.
//
// Cada KPI tem 2 linhas:
//   - label (ex.: "Pendências")
//   - valor "X / Y" (ou apenas "X" quando o total nao se aplica)
//
// Onda 5.x (2026-05-27): rev. do cockpit pedida pelo consultor.
//   - Removida a 3a linha de cada box (hint detalhado) — informacao
//     redundante com o que ja aparece nas panes do drawer.
//   - "Meses da implementação" foi para a ultima posicao (passou de
//     primeiro a quarto) e renomeado para "Meses calculados".
//   - "Ações necessárias" virou "Pendências".
//   - "Cálculos na fila" virou "Cálculos" e passou a mostrar X/Y onde
//     X = blocos concluidos (state in success|warning) e Y = total de
//     blocos visiveis no mes (``progressOverview.queue.done`` e
//     ``.total``).
//
// Os valores chegam por props (vindos de ``InputsV3``); defaults servem
// so para storybook/sandbox sem backend.
// ---------------------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import useProgressStyles from "./styles";

const CockpitStrip = ({
  monthsImplementation,
  inputsSent,
  actionsCount,
  blocksDone,
  blocksTotal,
}) => {
  const classes = useProgressStyles();

  const totalActions =
    (actionsCount.decisions || 0) +
    (actionsCount.uploads || 0) +
    (actionsCount.reenvios || 0) +
    (actionsCount.errors || 0);

  return (
    <div className={classes.cockpit}>
      <div className={classes.kpis}>
        <div className={classes.kpi}>
          <span className={classes.kpiLabel}>Inputs enviados</span>
          <span className={classes.kpiValue}>
            {inputsSent.sent}
            <span className={classes.kpiValueTotal}>
              {" / " + inputsSent.total}
            </span>
          </span>
        </div>

        <div className={classes.kpi}>
          <span className={classes.kpiLabel}>Pendências</span>
          <span className={classes.kpiValue}>{totalActions}</span>
        </div>

        <div className={classes.kpi}>
          <span className={classes.kpiLabel}>Cálculos</span>
          <span className={classes.kpiValue}>
            {blocksDone}
            <span className={classes.kpiValueTotal}>{" / " + blocksTotal}</span>
          </span>
        </div>

        <div className={classes.kpi}>
          <span className={classes.kpiLabel}>Meses calculados</span>
          <span className={classes.kpiValue}>
            {monthsImplementation.done + monthsImplementation.stale}
            <span className={classes.kpiValueTotal}>
              {" / " + monthsImplementation.total}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

CockpitStrip.propTypes = {
  monthsImplementation: PropTypes.shape({
    done: PropTypes.number,
    stale: PropTypes.number,
    total: PropTypes.number,
  }),
  inputsSent: PropTypes.shape({
    sent: PropTypes.number,
    action: PropTypes.number,
    waiting: PropTypes.number,
    total: PropTypes.number,
  }),
  actionsCount: PropTypes.shape({
    decisions: PropTypes.number,
    uploads: PropTypes.number,
    reenvios: PropTypes.number,
    errors: PropTypes.number,
    recalcs: PropTypes.number,
  }),
  blocksDone: PropTypes.number,
  blocksTotal: PropTypes.number,
};

CockpitStrip.defaultProps = {
  monthsImplementation: { done: 14, stale: 4, total: 30 },
  inputsSent: { sent: 23, action: 3, waiting: 8, total: 34 },
  actionsCount: {
    decisions: 3,
    uploads: 3,
    reenvios: 1,
    errors: 1,
    recalcs: 0,
  },
  blocksDone: 0,
  blocksTotal: 0,
};

export default CockpitStrip;
